import Forms from "./Forms";
import React from "react";

const PhonesEditor = ({items = [], onChange}) => {
    const update = (i, patch) => {
        const copy = [...items];
        copy[i] = {...copy[i], ...patch};
        onChange(copy);
    };
    const remove = (i) => {
        const next = items.filter((_, idx) => idx !== i);
        onChange(next.length ? next : [{value: '', e164: '', primary: true}]);
    };
    const setPrimary = (i) => onChange(items.map((p, idx) => ({...p, primary: idx === i})));

    return (
        <div className="space-y-2">
            {items.map((p, i) => (
                <div key={i} className="grid grid-cols-1 md:grid-cols-6 gap-3 items-end">
                    <Forms.Text label="Telefon" value={p.value} onChange={v => update(i, {value: v})}/>
                    <Forms.Checkbox label="Primární" value={!!p.primary} onChange={() => setPrimary(i)}/>
                    <div className="md:col-span-3">
                        <div className="opacity-50 text-xs mt-2"></div>
                        <Forms.Button type="button" variant="danger" label="–" onClick={() => remove(i)}/>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PhonesEditor;